<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDocumenti > 0"
      item-key="_id"
      :headers="headers"
      :items="documenti"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="true"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Seleziona gli scontrini da fatturare</v-toolbar-title>
        <v-btn class = "ml-5" small color="success" @click.stop="onAggiungiTutti">Aggiungi tutti</v-btn>
      </v-toolbar>
    </template>
    <template v-slot:[`item.data`]="{ item }">
      <!-- {{ item.riferimento.data && item.riferimento.data.substring(0, 22) | date }} -->
      {{ item.data | date }}
    </template>
    <template v-slot:[`item.totale`]="{ item }">
      {{ item.totale | euro }}
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="scontriniSelected">
        <v-tabs dense v-model="tab">
          <v-tab>Elenco righe{{item.name}}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <dettaglio-scontrino :idDocumento="item._id"/>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>
    <template v-slot:no-data>
      Nessun dato presente... Hai selezionato i clienti ?
    </template>    
    </v-data-table>  
  </div>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import DettaglioScontrino from './sceltaScontriniDettaglio.vue'
/*   import configurazioni from '@/services/configurazioniService.js'
  import moment from 'moment' */
  import scontrini from '@/services/scontriniService.js'

  export default {
    components: {
      DettaglioScontrino
    },
    props: {
      idsClienti: Array,
      dateScontrini: Object
    },
    data () {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totaleDocumenti: 0,
        documenti: [],
        selected: [],
        loading: false,
        options: {},
        headers: [
          { text: 'Scontrino', value: 'scontrino', align: 'start'},
          { text: 'Data', value: 'data'},
          { text: 'Importo', value: 'totale' },
          { text: 'Codice cliente', value: 'cliente.codice' },
          { text: 'Ragione Sociale', value: 'cliente.descrizione' },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null
      }
    },
    computed: {
      refreshList() {
        return this.$store.getters['documenti/refreshMultipleScontrini']
      },
      documentiSorted() {
        const els = this.documenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'multipleScontrini')
        }
      },
      selected(value) {
        this.$emit('selezione', value)
      }      
    },
    async mounted () {
      // await this.getDataFromApi()
    },
    methods: {
      onAggiungiTutti() {
        this.selected = [...this.documenti]
      },
      async getDataFromApi () {
        if (this.idsClienti.length === 0) return
        try {
          this.loading = true
          const filtri = { nominativo: this.idsClienti, ...this.dateScontrini }
          const data = await scontrini.getElencoScontriniNonRiscosso(filtri)
          this.documentiRaw = data && data.total_rows > 0 ? data.rows : []
          // this.documenti = this.datiVisualizzazione(this.documentiRaw)
          this.documenti = this.documentiRaw
          this.totaleDocumenti = data.total_rows
        } catch(err) {
          this.documenti = []
          this.totaleDocumenti = 0
        } finally {
          this.annullaSelezione()
          this.loading = false
        }
      },

      clickRow(item, options) {

      },
      dblclickRow(event, options) {
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
          const nominativo = el.cliente ? el.cliente.codice + '-' + el.cliente.descrizione : ''
          return { ...el, nominativo: nominativo }
        })
        return elaborati
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }         
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

</style>
